import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Trans } from '@wix/cli-i18n';
import { useVeloClient } from '@wix/velo-client';
import { useAsync, Spinner, Alert, Badge, Text } from '@wix/cli-ui-kit';
import { createDependenciesService } from '../../services/dependencies.js';
import { useProjectModel } from '../../model.js';

interface Props {
  packageName?: string;
}

export const InstallCommand: FC<Props> = ({ packageName }) => {
  const { model } = useProjectModel();
  const veloClient = useVeloClient();

  const { status } = useAsync(async () => {
    const { projectFolder } = model;
    const service = await createDependenciesService(projectFolder, veloClient);

    await service.install(packageName);
  }, []);

  return match(status, {
    Loading: () => (
      <Spinner
        text={
          packageName ? (
            <Trans
              i18nKey="install_command.package.loading"
              values={{ packageName }}
              components={[<Text bold />]}
            />
          ) : (
            <Trans i18nKey="install_command.all_packages.loading" />
          )
        }
      />
    ),
    Error: () => null,
    Success: () => (
      <Alert type="success">
        <Badge skin="success">
          <Trans i18nKey="general.success" />
        </Badge>{' '}
        {packageName ? (
          <Trans
            i18nKey="install_command.package.success"
            values={{ packageName }}
            components={[<Text bold />]}
          />
        ) : (
          <Trans i18nKey="install_command.all_packages.success" />
        )}
      </Alert>
    ),
  });
};
